import { useState, type ComponentProps } from "react";
import { useQuery } from "@tanstack/react-query";
import type { Platform } from "@aco/core";
import { trpc } from "@/lib/trpc";
import EntityBreakdown from "./EntityBreakdown";

// By campaign and By creative with the Company's extra metrics as columns.
// Reach is asked of Meta and TikTok for exactly this period and Filter, so the
// values are read only while one of those columns is showing.
export default function EntityBreakdownWithExtras({
  extraScope,
  ...props
}: ComponentProps<typeof EntityBreakdown> & {
  orgSlug: string;
  extraScope: { start: string; end: string; platforms: Platform[]; segmentId?: string };
}) {
  const [shown, setShown] = useState(false);
  const optedIn = useQuery(trpc.extraMetrics.get.queryOptions({ orgSlug: props.orgSlug }));
  const metrics = optedIn.data?.metrics ?? [];
  const values = useQuery({
    ...trpc.extraMetrics.entities.queryOptions({
      orgSlug: props.orgSlug,
      ...extraScope,
      level: props.kind === "campaign" ? "campaign" : "ad",
    }),
    enabled: shown && metrics.length > 0 && extraScope.platforms.length > 0,
  });
  return (
    <EntityBreakdown
      {...props}
      extraMetrics={metrics}
      extraValues={values.data?.rows}
      onExtraColumnsShown={setShown}
    />
  );
}
